module.exports = __webpack_public_path__ + "img/banner1.f86414c.jpg";